import { withStyles } from '@material-ui/core';

export default Component => withStyles(styles)(Component);

const styles = theme => ({
    text: {},
    oneLine: {
        display: 'flex',
    },
    oneLineChild: {
        margin: '0 16px 0 0',
        flex: '1 1',
        '&:last-child': {
            margin: 0,
        },
    },
    selectContainer: {
        width: '100%',
    },
    recurlyContainer: {
        width: '100%',
    },

    recurlyLabel: {
        padding: '0 2px',
        transform: 'translate(10px, -7px) scale(0.75)',
        background: '#fff',
    },

    phoneContainer: {
        width: '100%',
        padding: '6px 14px',
        border: 'solid 1px rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
    },
    phoneLabel: {
        padding: '0 2px',
        transform: 'translate(55px, 14px) scale(1)',
    },
    phoneContainerFocus: {
        padding: '5px 13px',
        border: 'solid 2px #607d8b',
    },
    phoneLabelFocus: {
        transform: 'translate(10px, -7px) scale(0.75)',
        background: '#fff',
    },
    imageContainer: {
        width: '100%',
        padding: '13px 14px',
        border: 'solid 1px rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
    },
    imageLabel: {
        transform: 'translate(10px, -7px) scale(0.75) !important',
        background: '#fff',
        padding: '0 3px',
    },
    imageButtons: {
        padding: '14px 0 0',
    },
    imageUploadButtonWrapper: {
        position: 'relative',
        display: 'inline-block',
        margin: '0 16px 0 0',
    },
    imageFileInput: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        opacity: 0,
        left: 0,
        top: 0,
        cursor: 'pointer',
    },
    checkBoxContainer: {
        width: '100%',
        position: 'relative',
    },
    checkBoxError: {
        color: '#f00 !important',
    },
    checkBoxHelpIcon: {
        margin: '0 0 0 8px',
        fontSize: '16pt',
        verticalAlign: 'middle',
        color: theme.palette.text.secondary,
    },
    preview: {
        position: 'relative',
    },
    copyTextFieldInput: {
        background: '#eee',
    },
    row: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
});
